import { validateFields } from './fields-validator';
import { showLoader, hideLoader } from '../loader';

const phoneOptions = {
  mask: '+9{5,15}',
  placeholder: '',
  showMaskOnHover: false,
};

let activeForm = null;

export function initFormValidator() {
  const forms = document.querySelectorAll('form:not(.js-no_validate)');

  if (!forms.length) return;

  forms.forEach((form) => {
    const dismissButton = form.querySelector('.js-error-dismiss');
    if (dismissButton) {
      dismissButton.addEventListener('click', () => form.classList.remove('m-error'));
    }

    const inputFields = Array.from(form.elements).filter(
      (el) => ['INPUT', 'TEXTAREA', 'SELECT'].includes(el.tagName) && el.name,
    );

    initFieldsValidation(inputFields);

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const hasInvalidFields = validateFields(inputFields);

      if (hasInvalidFields) {
        const firstInvalid = form.querySelector('.js-form_field.m-invalid');
        firstInvalid?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      activeForm = form;

      grecaptcha.execute();
    });
  });

  window.onSubmitReCaptcha = async function (token) {
    if (!activeForm) return;

    const formData = new FormData(activeForm);
    const url = activeForm.getAttribute('action') || '/';
    const method = activeForm.method || 'POST';

    formData.append('token', token);

    activeForm.classList.remove('m-success', 'm-error');

    const defaultErrorText = 'Something went wrong. Please try again later.';
    const errorMessageElem = activeForm.querySelector('.js-error-message');

    showLoader(activeForm);
    activeForm.scrollIntoView({ behavior: 'smooth', block: 'start' });

    try {
      const response = await fetch(url, {
        method: method,
        body: formData,
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const json = await response.json();

      if (json.success === false) {
        if (errorMessageElem) {
          errorMessageElem.textContent = json.data
            ? JSON.stringify(json.data).slice(1, -1)
            : defaultErrorText;
        }
        activeForm.classList.add('m-error');
        grecaptcha.reset();
        hideLoader(activeForm);
        return;
      }

      // SUCCESS state
      activeForm.classList.add('m-success');
      setTimeout(() => activeForm.classList.remove('m-success'), 8000);
      activeForm.reset();

      grecaptcha.reset();
      hideLoader(activeForm);
    } catch (error) {
      // ERROR state
      if (errorMessageElem) {
        errorMessageElem.textContent = defaultErrorText;
      }
      activeForm.classList.add('m-error');
      grecaptcha.reset();
      hideLoader(activeForm);
    }
  };

  async function initFieldsValidation(inputFields) {
    const telFields = inputFields.filter((field) => field.type === 'tel');

    if (telFields.length) {
      const { default: Inputmask } = await import('inputmask');
      telFields.forEach((field) => Inputmask(phoneOptions).mask(field));
    }

    inputFields.forEach((field) => {
      if (field.type === 'checkbox' || field.tagName === 'SELECT') {
        field.addEventListener('change', () => validateSingleField(field));
      } else {
        field.addEventListener('blur', () => validateSingleField(field));

        // Clear error immediately as user types, but only if the field already has one
        field.addEventListener('input', () => {
          const formField = field.closest('.js-form_field');
          if (formField && formField.classList.contains('m-invalid')) {
            validateSingleField(field);
          }
        });
      }
    });
  }

  function validateSingleField(field) {
    validateFields([field]);
  }
}
